// extracted by mini-css-extract-plugin
module.exports = {"tagline":"styles_tagline__1XwFM","titleOrg":"styles_titleOrg__2RYY9","txt":"styles_txt__1lAFh","txtOrg":"styles_txtOrg__1XW2C"};